(() => {
  'use strict';

  const VERSION = '1.0.17-2026-09-19-NEUTRAL-PREFERENCE';
  const GENERATED_AT = '2026-09-19T13:42:00+02:00';

  // Founder decision 2026-09-18: every live Shopify SKU with positive stock is recommendation-eligible.
  // Regulatory/compliance follow-up is tracked separately and does not create a Calculator denylist.
  const CUSTOMER_RELEASE_BLOCKED_SKUS = new Set();

  // Product catalog is deliberately separated from Shopify commerce data.
  // SKU is the stable join key; live variant id / price / availability / stock come from the selected Shopify collection.
  const CATALOG = Object.freeze({
    groups: {
      ND_GEL45: { brand:'Nduranz', title:'NRGY Gel 45', role:'CARB_SODIUM', form:'gel', carb:45, sodium:460, caffeine:0, mtc:true, capacity:1, unit:'gel', skus:['NDURANZ-NRGY-45-LEMON','NDURANZ-NRGY-45-ORANGE','NDURANZ-NRGY-45-COLA'], autoMix:true, sports:['run','bike','tri'] },
      ND_GEL45_EFREE: { brand:'Nduranz', title:'Nrgy Gel 45 (Elektrolitmentes)', role:'CARB', form:'gel', carb:45, sodium:0, caffeine:0, mtc:true, capacity:1, unit:'gel', skus:['NDURANZ-NRGY-45-ZERO'], autoMix:false, sports:['run','bike','tri'] },
      ND_GEL45_CAFF: { brand:'Nduranz', title:'Nrgy Gel 45 + Koffein', role:'CAFFEINE_SUB', form:'gel', carb:45, sodium:460, caffeine:65, mtc:true, capacity:1, unit:'gel', skus:['NDURANZ-NRGY-45-CAF-CHERRY','NDURANZ-NRGY-45-CAF-MANGO'], autoMix:true, sports:['run','bike','tri'], maxDaily: null },
      ND_DRINK45: { brand:'Nduranz', title:'Nrgy Drink 45', role:'CARB_FLUID_SODIUM', form:'drink', carb:45, sodium:460, caffeine:0, mtc:true, capacity:25, unit:'serving', water:500, skus:['NDURANZ-NRGY-45-ISO-LEMON','NDURANZ-NRGY-45-ISO-ORANGE'], autoMix:true, sports:['run','bike','tri'] },
      ND_DRINK90: { brand:'Nduranz', title:'Nrgy Drink 90', role:'CARB_FLUID_SODIUM', form:'drink', carb:90, sodium:460, caffeine:0, mtc:true, capacity:12, unit:'serving', water:500, skus:['NDURANZ-NRGY-90-ISO-LEMON','NDURANZ-NRGY-90-ISO-ORANGE'], autoMix:true, sports:['run','bike','tri'] },
      ND_DRINK_EFREE: { brand:'Nduranz', title:'Nrgy Drink (Elektrolitmentes)', role:'CARB_FLUID', form:'drink', carb:22.5, sodium:0, caffeine:0, mtc:true, capacity:50, unit:'scoop', waterFlexible:true, maxDosesPer500:4, skus:['NDURANZ-NRGY-ISO-0ELECTROLYTE','NDURANZ-NRGY-ISO-0ELECTROLYTE-APPLE'], autoMix:true, sports:['run','bike','tri'] },
      ND_ZERO: { brand:'Nduranz', title:'Zero Drink Pezsgőtabletta', role:'SODIUM', form:'tablet', carb:0, sodium:300, caffeine:0, mtc:true, capacity:20, unit:'tablet', water:500, skus:['NDURANZ-PEZSGŐTABLETTA-LEMON','NDURANZ-PEZSGŐTABLETTA-BERRY','NDURANZ-PEZSGŐTABLETTA-GRAPEFRUIT'], autoMix:true, sports:['run','bike','tri'] },
      ND_CAFF_CAP: { brand:'Nduranz', title:'Koffein 50 mg kapszula', role:'CAFFEINE', form:'capsule', carb:0, sodium:0, caffeine:50, mtc:true, capacity:100, unit:'capsule', skus:['NDURANZ-KOFFEIN'], autoMix:false, sports:['run','bike','tri'] },
      IAM_120: { brand:'I:AM', title:'Mineral Tabs Sótabletta - 120 db', role:'SODIUM', form:'tablet', carb:0, sodium:200, caffeine:0, mtc:true, capacity:120, unit:'tablet', skus:['I-AM-MINERAL-TABS'], autoMix:false, sports:['run','bike','tri'], maxDaily:8 },
      IAM_RACE: { brand:'I:AM', title:'Mineral Tabs Race Pack Sótabletta', role:'SODIUM', form:'tablet', carb:0, sodium:200, caffeine:0, mtc:true, capacity:20, unit:'tablet', skus:['I-AM-RACE-PACK'], autoMix:false, sports:['run','bike','tri'], maxDaily:8 },
      IAM_120_CAFF: { brand:'I:AM', title:'Mineral Tabs Sótabletta + Koffein - 120 db', role:'SODIUM_CAFFEINE', form:'tablet', carb:0, sodium:200, caffeine:10, mtc:true, capacity:120, unit:'tablet', skus:['I-AM-MINERAL-TAPS+CAF'], autoMix:false, sports:['run','bike','tri'], maxDaily:8 },
      IAM_RACE_CAFF: { brand:'I:AM', title:'Mineral Tabs Race Pack + koffein', role:'SODIUM_CAFFEINE', form:'tablet', carb:0, sodium:200, caffeine:10, mtc:true, capacity:20, unit:'tablet', skus:['I-AM-RACE-PACK+CAF'], autoMix:false, sports:['run','bike','tri'], maxDaily:8 },
      PF30: { brand:'PF&H', title:'PF 30 Gel', role:'CARB', form:'gel', carb:30, sodium:0, caffeine:0, mtc:true, capacity:1, unit:'gel', skus:['PF30-GEL'], autoMix:false, sports:['run','bike','tri'], maxDaily:20 },
      PF30_CAFF: { brand:'PF&H', title:'PF 30 Caffeine Gel', role:'CAFFEINE_SUB', form:'gel', carb:30, sodium:0, caffeine:100, mtc:true, capacity:1, unit:'gel', skus:['PF30-CAFF-GEL'], autoMix:false, sports:['run','bike','tri'], maxDaily:4 },
      PF90: { brand:'PF&H', title:'PF 90 Gel', role:'CARB', form:'gel', carb:30, sodium:0, caffeine:0, mtc:true, capacity:3, unit:'30g portion', skus:['PF90-GEL'], autoMix:false, sports:['run','bike','tri'], maxDaily:20 },
      PF300: { brand:'PF&H', title:'PF 300 Flow Gel', role:'CARB', form:'gel', carb:30, sodium:0, caffeine:0, mtc:true, capacity:10, unit:'30g portion', skus:['PF300-FG'], autoMix:false, sports:['run','bike','tri'], maxDaily:20, accessory:'PF_FLASK', preferSports:['bike','tri'] },
      PF_MIX: { brand:'PF&H', title:'Carb & Electrolyte Drink Mix', role:'CARB_FLUID_SODIUM', form:'drink', carb:30, sodium:500, caffeine:0, mtc:true, capacity:15, unit:'serving', water:500, skus:['PF60-MIX'], autoMix:false, sports:['run','bike','tri'], maxDaily:3 },
      PF_CHEW: { brand:'PF&H', title:'PF 30 Chew', role:'CARB', form:'chew', carb:30, sodium:0, caffeine:0, mtc:false, capacity:1, unit:'packet', skus:['PF30-CHEW-OR','PF30-CHEW-WM'], autoMix:true, sports:['run','bike','tri'], maxDaily:4, maxTargetGph:60 },
      PF_CAPS: { brand:'PF&H', title:'PF&H Electrolyte Capsules', role:'SODIUM', form:'capsule', carb:0, sodium:250, caffeine:0, mtc:true, capacity:15, unit:'capsule', skus:['SWEATSALTS-BOX15'], autoMix:false, sports:['run','bike','tri'], maxDaily:10, manualOnly:false },
      PH1000: { brand:'PF&H', title:'PH 1000 Pezsgőtabletta', role:'SODIUM', form:'tablet', carb:2.2, sodium:500, caffeine:0, mtc:true, capacity:10, unit:'tablet', water:500, skus:['PH-1000-TUBE-UK'], autoMix:false, sports:['run','bike','tri'] },
      PH1500: { brand:'PF&H', title:'PH 1500 Pezsgőtabletta', role:'SODIUM', form:'tablet', carb:1.8, sodium:750, caffeine:0, mtc:true, capacity:10, unit:'tablet', water:500, skus:['PH-1500-TUBE-UK'], autoMix:false, sports:['run','bike','tri'] },

      PH500: { brand:'PF&H', title:'PH 500 Pezsgőtabletta', role:'SODIUM_LATER', form:'tablet', carb:0, sodium:250, caffeine:0, mtc:true, capacity:15, unit:'tablet', water:500, skus:['PH-500-TUBE-UK'], autoMix:false, sports:['run','bike','tri'], manualOnly:true },
      VOOM_ELECTRO: { brand:'VOOM', title:'Pocket Rocket Electro Energiaszelet', role:'CARB', form:'chew', carb:45, sodium:0, caffeine:0, mtc:false, capacity:1, unit:'bar', skus:['VOOM-POCKET-ROCKET-LEMON'], autoMix:false, sports:['run','bike','tri'], maxTargetGph:60 },
      VOOM_BETA: { brand:'VOOM', title:'Pocket Rocket Beta Blast Energiaszelet', role:'SPECIAL', form:'chew', carb:43, sodium:0, caffeine:null, mtc:false, capacity:1, unit:'bar', skus:['VOOM-POCKET-ROCKET-ORANGE'], autoMix:false, sports:['run','bike','tri'], manualOnly:true },
      PF_FLASK: { brand:'PF&H', title:'Flow Flask 300', role:'ACCESSORY', form:'accessory', capacity:1, unit:'flask', skus:['PFH-300G-FLASK'], autoMix:false, sports:['run','bike','tri'] },
      ND_BICARB: { brand:'Nduranz', title:'Bicarb - Szódabikarbóna', role:'PRE_EVENT_SPECIAL', form:'capsule', capacity:180, unit:'capsule', skus:['NDURANZ-SODIUM-BICARB'], manualOnly:true },
      ND_REGEN: { brand:'Nduranz', title:'Nduranz Regen Regenerációs Italpor', role:'RECOVERY', form:'recovery', capacity:1, unit:'tub', skus:['NDURANZ-REGEN'], manualOnly:true },
      PICKLE: { brand:'4Endurance', title:'Pickle Juice Shot - 60 ml', role:'SPECIAL', form:'shot', capacity:1, unit:'shot', skus:['4ENDURANCE-PICLKE-SHOT'], manualOnly:true },
      PJUR100: { brand:'Pjur', title:'2SKIN FULL BODY - 100 ml', role:'SKIN', form:'topical', capacity:1, unit:'bottle', skus:['PJUR-2SKIN-100ML'], manualOnly:true },
      PJUR20: { brand:'Pjur', title:'2SKIN FULL BODY - 20 ml', role:'SKIN', form:'topical', capacity:1, unit:'bottle', skus:['PJUR-2SKIN-20ML'], manualOnly:true },
      SNB: { brand:"Squirrel's Nut Butter", title:'Squirrel’s Nut Butter Kidörzsölődés Elleni Balzsam', role:'SKIN', form:'topical', capacity:1, unit:'tin', skus:['SNB-ANTI-CHAFE-56GR'], manualOnly:true },
      PELOTAN_ROLL: { brand:'Pelotan', title:'SPF30 Sport Naptej Roll-On – 50 ml', role:'SUN', form:'topical', capacity:1, unit:'bottle', skus:['PELOTAN-SFT30-ROLLON'], manualOnly:true },
      PELOTAN_SPRAY: { brand:'Pelotan', title:'SPF30 Sport Naptej Spray – 100 ml', role:'SUN', form:'topical', capacity:1, unit:'bottle', skus:['PELOTAN-SFP30-SPRAY-100ML'], manualOnly:true },
      PILLAR: { brand:'Pillar Performance', title:'PILLAR Performance Triple Magnézium Por', role:'RECOVERY_SUPPORT', form:'supplement', capacity:1, unit:'tub', skus:['PILLAR-MAGNESIUM-200GR-LEMON','PILLAR-MAGNESIUM-200GR-BERRY'], autoMix:false, manualOnly:true }
    }
  });

  const CORE_GROUP_KEYS = [
    'ND_GEL45','ND_GEL45_EFREE','ND_DRINK45','ND_DRINK90','ND_DRINK_EFREE',
    'PF30','PF90','PF300','PF_MIX','PF_CHEW','VOOM_ELECTRO'
  ];
  const SODIUM_GROUP_KEYS = ['ND_ZERO','IAM_120','IAM_RACE','PF_CAPS','PH1000','PH1500','PH500'];

  const PAIR_FAMILIES = [
    ['ND_GEL45','PF30'], ['ND_GEL45','PF_CHEW'], ['ND_GEL45','ND_DRINK_EFREE'],
    ['PF30','ND_DRINK_EFREE'], ['PF_CHEW','ND_DRINK_EFREE'], ['PF30','PF_MIX'],
    ['ND_GEL45','PF_MIX'], ['ND_DRINK45','PF30'], ['PF30','PF_CHEW'],
    ['PF90','PF_MIX'], ['PF300','PF_MIX'],
    ['ND_GEL45_EFREE','PF30'], ['ND_GEL45_EFREE','PF_CHEW'], ['ND_GEL45_EFREE','ND_DRINK_EFREE'],
    ['VOOM_ELECTRO','PF30'], ['VOOM_ELECTRO','PF_CHEW'], ['VOOM_ELECTRO','ND_DRINK_EFREE'], ['VOOM_ELECTRO','PF_MIX']
  ];

  function n(v, fallback=0) { const x=Number(v); return Number.isFinite(x)?x:fallback; }
  function clamp(v,lo,hi){ return Math.max(lo,Math.min(hi,v)); }
  function round50(v){ return Math.round(v/50)*50; }
  function uniq(xs){ return [...new Set(xs)]; }
  function sum(xs,fn){ return xs.reduce((a,x)=>a+fn(x),0); }
  function liveFor(group, liveMap) {
    return group.skus.map(sku=>liveMap?.get?.(String(sku))).filter(Boolean);
  }
  function availableVariants(group, liveMap) {
    return liveFor(group,liveMap).filter(v=>
      !CUSTOMER_RELEASE_BLOCKED_SKUS.has(String(v.sku)) &&
      v.available &&
      (!Number.isFinite(Number(v.inventoryQuantity)) || Number(v.inventoryQuantity)>0)
    );
  }
  function groupLive(group, liveMap) { return availableVariants(group,liveMap).length>0; }
  function targetCarbRate(carb) {
    if (!carb) return null;
    if (Number.isFinite(carb.executionGph)) return carb.executionGph;
    if (Array.isArray(carb.executionRangeGph)) return (carb.executionRangeGph[0]+carb.executionRangeGph[1])/2;
    return null;
  }
  function carbPass(totalCarb, durationH, carb) {
    if (!carb || durationH<=0) return false;
    if (carb.kind==='short') {
      const r=carb.totalRangeG||[0,0];
      return totalCarb>=r[0]-1e-9 && totalCarb<=r[1]+1e-9;
    }
    const avg=totalCarb/durationH;
    if (Array.isArray(carb.executionRangeGph)) return avg>=carb.executionRangeGph[0]-1e-9 && avg<=carb.executionRangeGph[1]+1e-9;
    const t=n(carb.executionGph);
    if(t<=0)return false;
    // Founder-approved Product Solver execution fit (2026-09-19):
    // keep the nutrition target unchanged, but allow physical product execution
    // within ±10% OR ±7.5 g total event carbohydrate, whichever is wider.
    const targetTotal=t*durationH;
    const allowedTotal=Math.max(targetTotal*0.10,7.5);
    return Math.abs(totalCarb-targetTotal)<=allowedTotal+1e-9;
  }
  function mtcPass(uses, carb) {
    if (!carb?.mtcRequired) return true;
    return uses.every(u=>u.count<=0 || CATALOG.groups[u.group].mtc===true);
  }
  function groupMaxUse(group, durationH) {
    if (!Number.isFinite(group.maxDaily)) return Infinity;
    return Math.floor(group.maxDaily*Math.max(1,Math.ceil(durationH/24)));
  }
  function executionMaxUse(group, durationH, input) {
    let max=groupMaxUse(group,durationH);
    // Running execution guardrail: at most one pre-mixed drink bottle.
    // Flexible drink powder may use multiple validated doses in that one bottle;
    // fixed 500 ml servings are capped at one serving. Remaining fluid can be water.
    if(input?.sport==='run' && group?.form==='drink'){
      const oneBottleDoseCap=group.waterFlexible ? Math.max(1,n(group.maxDosesPer500,1)) : 1;
      max=Math.min(max,oneBottleDoseCap);
    }
    return max;
  }
  function preparedFluidForUse(groupKey,count) {
    const g=CATALOG.groups[groupKey];
    if (!count || !g) return 0;
    if (g.waterFlexible) return Math.ceil(count/Math.max(1,g.maxDosesPer500||1))*500;
    if (g.water) return count*g.water;
    return 0;
  }
  function preparedBottleCountForUse(groupKey,count){
    const g=CATALOG.groups[groupKey];
    if(!count||!g)return 0;
    if(g.waterFlexible)return Math.ceil(count/Math.max(1,g.maxDosesPer500||1));
    if(g.water)return Math.ceil((count*g.water)/500);
    return 0;
  }
  function preparedBottleCountForUses(uses){
    return sum(uses||[],u=>preparedBottleCountForUse(u.group,u.count));
  }
  function hasCarbDrink(plan){
    return (plan?.uses||[]).some(u=>u.count>0&&CATALOG.groups[u.group]?.form==='drink');
  }
  function nutritionForUses(uses) {
    let carb=0,sodium=0,prepared=0;
    for(const u of uses){
      const g=CATALOG.groups[u.group]; if(!g||u.count<=0) continue;
      carb += n(g.carb)*u.count;
      sodium += n(g.sodium)*u.count;
      prepared += preparedFluidForUse(u.group,u.count);
    }
    return {carb,sodium,prepared};
  }
  function usesKey(uses){ return uses.filter(u=>u.count>0).map(u=>`${u.group}:${u.count}`).sort().join('|'); }

  function findCarbUsePlans(route, input, targets, liveMap) {
    const h=Math.max(1/60,n(input.durationMin)/60);
    const target=targetCarbRate(targets.carb);
    const totalTarget=targets.carb?.kind==='short'
      ? ((targets.carb.totalRangeG?.[0]||0)+(targets.carb.totalRangeG?.[1]||0))/2
      : target*h;

    if (targets.carb?.kind==='short' && (targets.carb.totalRangeG?.[1]||0)===0) return [];

    let keys=CORE_GROUP_KEYS.filter(k=>{
      const g=CATALOG.groups[k];
      if (g.manualOnly) return false;
      if (route==='pfh' && g.brand!=='PF&H') return false;
      if (g.maxTargetGph && target && target>g.maxTargetGph) return false;
      if (!g.sports?.includes(input.sport)) return false;
      return groupLive(g,liveMap);
    });
    const families=keys.map(k=>[k]);
    for(const pair of PAIR_FAMILIES){
      if(pair.every(k=>keys.includes(k))) families.push(pair);
    }
    const found=[];
    for(const fam of families){
      const a=CATALOG.groups[fam[0]], b=fam[1]?CATALOG.groups[fam[1]]:null;
      const maxA=Math.min(Math.ceil((Math.max(totalTarget,30)+Math.max(n(a.carb),1)*2)/Math.max(n(a.carb),1)), executionMaxUse(a,h,input));
      for(let ca=0;ca<=maxA;ca++){
        let cb=0;
        if(b){
          const rem=totalTarget-ca*n(a.carb);
          cb=Math.max(0,Math.round(rem/Math.max(n(b.carb),1)));
          cb=Math.min(cb,executionMaxUse(b,h,input));
        }
        const trials=b?uniq([cb-1,cb,cb+1].filter(x=>x>=0)):[0];
        for(const countB of trials){
          if(ca===0&&countB===0) continue;
          const uses=[{group:fam[0],count:ca}]; if(b) uses.push({group:fam[1],count:countB});
          const nut=nutritionForUses(uses);
          if(!carbPass(nut.carb,h,targets.carb)) continue;
          if(!mtcPass(uses,targets.carb)) continue;
          if(uses.some(u=>u.count>executionMaxUse(CATALOG.groups[u.group],h,input))) continue;
          const preparedBottles=preparedBottleCountForUses(uses);
          if(input?.sport==='run' && preparedBottles>1) continue;
          if(input?.sport==='bike' && preparedBottles>2) continue;
          found.push({uses,nut});
        }
      }
    }
    const dedup=new Map();
    for(const f of found){ const k=usesKey(f.uses); if(!dedup.has(k)) dedup.set(k,f); }
    return [...dedup.values()];
  }

  function fluidRateCandidates(range, minPreparedRate=0) {
    if(!range) return [Math.max(0,minPreparedRate)];
    const [lo,hi]=range;
    const mid=(lo+hi)/2;
    const xs=[lo,mid,hi,round50(lo),round50(mid),round50(hi),500,600,650,700,750,800,900,1000]
      .map(x=>Math.round(x/10)*10)
      .filter(x=>x>=lo-1e-9 && x<=hi+1e-9 && x>=minPreparedRate-1e-9);
    return uniq(xs).sort((a,b)=>Math.abs(a-mid)-Math.abs(b-mid));
  }

  function sodiumAdjusterKeys(route, targetRange) {
    const mid=targetRange ? (targetRange[0]+targetRange[1])/2 : 0;
    const all=SODIUM_GROUP_KEYS.filter(k=>{
      const g=CATALOG.groups[k];
      if(g.manualOnly) return false;
      if(route==='pfh' && g.brand!=='PF&H') return false;
      return true;
    });
    // Prefer fine-grain swallowable adjusters in standard bands; prepared tablets remain available when they fit better.
    return all.sort((a,b)=>{
      const ga=CATALOG.groups[a],gb=CATALOG.groups[b];
      const pa=ga.water?1:0,pb=gb.water?1:0;
      if(mid<=700 && pa!==pb) return pa-pb;
      return n(ga.sodium)-n(gb.sodium);
    });
  }

  function completeHydration(route,input,targets,carbPlan,liveMap) {
    const h=Math.max(1/60,n(input.durationMin)/60);
    const fRange=targets.fluid?.rangeMlph||null;
    const sRange=targets.sodium?.rangeMgL||null;
    const base=carbPlan.nut;
    const basePreparedBottles=preparedBottleCountForUses(carbPlan.uses);
    const minPreparedRate=base.prepared/h;
    const rates=fluidRateCandidates(fRange,minPreparedRate);
    const results=[];
    for(const rate of rates){
      const totalFluidMl=rate*h;
      if(totalFluidMl+1e-9<base.prepared) continue;
      // Bike hard execution gate: if two product-mix bottles are already occupied,
      // the same plan cannot also require extra plain water (which would mean a third bottle).
      if(input?.sport==='bike' && basePreparedBottles>=2 && totalFluidMl>base.prepared+1e-9) continue;
      if(!sRange){
        results.push({...carbPlan,fluidMlph:rate,totalFluidMl,totalSodium:base.sodium,sodiumMgL:totalFluidMl>0?base.sodium/(totalFluidMl/1000):0,adjuster:null});
        continue;
      }
      const lowTotal=sRange[0]*(totalFluidMl/1000), highTotal=sRange[1]*(totalFluidMl/1000);
      if(base.sodium>=lowTotal-1e-9 && base.sodium<=highTotal+1e-9){
        results.push({...carbPlan,fluidMlph:rate,totalFluidMl,totalSodium:base.sodium,sodiumMgL:base.sodium/(totalFluidMl/1000),adjuster:null});
      }
      for(const key of sodiumAdjusterKeys(route,sRange)){
        const g=CATALOG.groups[key];
        if(!groupLive(g,liveMap)) continue;
        const dose=n(g.sodium); if(dose<=0) continue;
        const maxByDaily=groupMaxUse(g,h);
        const needLow=Math.max(0,Math.ceil((lowTotal-base.sodium-1e-9)/dose));
        const needHigh=Math.max(0,Math.floor((highTotal-base.sodium+1e-9)/dose));
        const lo=Math.max(0,needLow), hi=Math.min(needHigh,maxByDaily);
        for(let count=lo;count<=Math.min(hi,lo+3);count++){
          if(count<=0) continue;
          const adjPrepared=preparedFluidForUse(key,count);
          const adjusterBottles=preparedBottleCountForUse(key,count);
          // RUN: one product-mix bottle max, leaving the other carried bottle for plain water.
          if(input?.sport==='run'){
            if(basePreparedBottles>1 || adjusterBottles>1) continue;
            if(basePreparedBottles>0 && adjusterBottles>0) continue;
          }
          // BIKE: max two carried bottles. Two mixed bottles are allowed only when they cover
          // the planned carried fluid; otherwise a third plain-water bottle would be required.
          if(input?.sport==='bike'){
            const mixedBottles=basePreparedBottles+adjusterBottles;
            if(mixedBottles>2) continue;
            if(mixedBottles>=2 && totalFluidMl>base.prepared+adjPrepared+1e-9) continue;
          }
          if(base.prepared+adjPrepared>totalFluidMl+1e-9) continue;
          const totalNa=base.sodium+count*dose;
          const conc=totalNa/(totalFluidMl/1000);
          if(conc<sRange[0]-1e-9||conc>sRange[1]+1e-9) continue;
          // Tiny carbs in PH tablets must still count toward whole-event carb fit.
          const totalCarb=base.carb+count*n(g.carb);
          if(!carbPass(totalCarb,h,targets.carb)) continue;
          results.push({...carbPlan,nut:{...base,carb:totalCarb,prepared:base.prepared+adjPrepared,sodium:totalNa},fluidMlph:rate,totalFluidMl,totalSodium:totalNa,sodiumMgL:conc,adjuster:{group:key,count}});
        }
      }
    }
    return results;
  }

  function allocateGroup(groupKey,doseCount,liveMap) {
    const group=CATALOG.groups[groupKey];
    if(!group||doseCount<=0) return {ok:true,items:[],cart:0,event:0};
    const packs=Math.ceil(doseCount/Math.max(1,group.capacity||1));
    const variants=availableVariants(group,liveMap).sort((a,b)=>n(b.inventoryQuantity)-n(a.inventoryQuantity));
    if(!variants.length) return {ok:false,items:[]};
    let left=packs,cart=0;
    const items=[];
    if(group.autoMix && variants.length>1 && packs>1){
      let cursor=0,safety=0;
      while(left>0 && safety<10000){
        const v=variants[cursor%variants.length];
        const cap=Number.isFinite(Number(v.inventoryQuantity))?Math.max(0,Number(v.inventoryQuantity)):Infinity;
        const existing=items.find(x=>x.sku===v.sku);
        const used=existing?.sellUnits||0;
        if(used<cap){
          if(existing) existing.sellUnits++; else items.push({sku:v.sku,title:v.title||group.title,variantTitle:v.variantTitle||'',sellUnits:1});

          left--; cart+=n(v.price);
        }
        cursor++; safety++;
        if(cursor%variants.length===0 && variants.every(v=>{
          const cap=Number.isFinite(Number(v.inventoryQuantity))?Math.max(0,Number(v.inventoryQuantity)):Infinity;
          const used=items.find(x=>x.sku===v.sku)?.sellUnits||0; return used>=cap;
        })) break;
      }
    } else {
      const v=variants.find(v=>!Number.isFinite(Number(v.inventoryQuantity))||Number(v.inventoryQuantity)>=packs);
      if(v){
        items.push({sku:v.sku,title:v.title||group.title,variantTitle:v.variantTitle||'',sellUnits:packs});
        cart=n(v.price)*packs; left=0;
        if(group.autoMix&&variants.length>1&&packs===1){
          items[0].alternatives=variants.map(x=>({sku:x.sku,title:x.title||group.title,variantTitle:x.variantTitle||''}));
        }
      }
    }
    if(left>0) return {ok:false,items:[]};
    const cheapest=variants.slice().sort((a,b)=>n(a.price)-n(b.price))[0];
    const event=n(cheapest?.price)*(doseCount/Math.max(1,group.capacity||1));
    return {ok:true,items,cart,event};
  }

  function allocatePlanItems(plan,liveMap) {
    const groups=[];
    for(const u of plan.uses) if(u.count>0) groups.push(u);
    if(plan.adjuster?.count>0) groups.push({group:plan.adjuster.group,count:plan.adjuster.count});
    if(plan.uses.some(u=>u.group==='PF300'&&u.count>0)) groups.push({group:'PF_FLASK',count:1});
    const merged=new Map();
    for(const g of groups) merged.set(g.group,(merged.get(g.group)||0)+g.count);
    let items=[],cart=0,event=0;
    for(const [group,count] of merged){
      const a=allocateGroup(group,count,liveMap); if(!a.ok) return {ok:false,items:[]};
      items.push(...a.items);
      cart+=a.cart;
      if(CATALOG.groups[group]?.role!=='ACCESSORY')event+=a.event;
    }
    return {ok:items.length>0,items,cartPriceCents:Math.round(cart*100),eventUseValueCents:Math.round(event*100)};
  }

  const MICRO_BASKET_LIMIT_CENTS=200000; // 2 000 Ft gross
  function catalogGroupForSku(sku){
    const key=String(sku||'');
    for(const [groupKey,g] of Object.entries(CATALOG.groups)){
      if((g.skus||[]).map(String).includes(key))return {groupKey,...g};
    }
    return null;
  }
  function isSingleUseFuelItem(item){
    const g=catalogGroupForSku(item?.sku);
    return !!g && n(g.capacity)===1 && n(g.carb)>0 && g.role!=='ACCESSORY';
  }
  function commercePolicyForAllocation(alloc){
    const items=alloc?.items||[];
    const micro=items.length>0 && n(alloc?.cartPriceCents)>=0 && n(alloc?.cartPriceCents)<MICRO_BASKET_LIMIT_CENTS && items.every(isSingleUseFuelItem);
    return {
      oneClickCartAllowed:!micro,
      reason:micro?'MICRO_BASKET_SINGLE_USE_FUEL':null,
      thresholdHuf:MICRO_BASKET_LIMIT_CENTS/100
    };
  }

  function preferenceFit(plan,preference){
    const forms=plan.uses.filter(u=>u.count>0).map(u=>CATALOG.groups[u.group].form);
    const unique=new Set(forms);
    if(preference==='none'||!preference) return 0;
    if(preference==='simple') return 100-Math.max(0,unique.size-1)*20;
    if(preference==='gel') return forms.length?Math.round(100*forms.filter(x=>x==='gel').length/forms.length):0;
    if(preference==='drink') return forms.length?Math.round(100*forms.filter(x=>x==='drink').length/forms.length):0;
    if(preference==='chew') return forms.length?Math.round(100*forms.filter(x=>x==='chew').length/forms.length):0;
    return 0;
  }
  function productGroupCount(plan){ return new Set(plan.uses.filter(u=>u.count>0).map(u=>u.group).concat(plan.adjuster?[plan.adjuster.group]:[])).size; }
  function nutritionDeviation(plan,targets,input){
    const h=Math.max(1/60,n(input.durationMin)/60);
    let score=0;
    const avg=plan.nut.carb/h;
    const target=targetCarbRate(targets.carb);
    if(target) score+=Math.abs(avg-target)/target;
    if(targets.fluid?.rangeMlph){ const m=(targets.fluid.rangeMlph[0]+targets.fluid.rangeMlph[1])/2; score+=Math.abs(plan.fluidMlph-m)/Math.max(1,m); }
    if(targets.sodium?.rangeMgL){ const m=(targets.sodium.rangeMgL[0]+targets.sodium.rangeMgL[1])/2; score+=Math.abs(plan.sodiumMgL-m)/Math.max(1,m); }
    return score;
  }

  function routeRank(a,b,route,input,targets){
    if(route==='cost'){
      if(a.alloc.cartPriceCents!==b.alloc.cartPriceCents)return a.alloc.cartPriceCents-b.alloc.cartPriceCents;
      if(a.alloc.eventUseValueCents!==b.alloc.eventUseValueCents)return a.alloc.eventUseValueCents-b.alloc.eventUseValueCents;
      const d=nutritionDeviation(a,targets,input)-nutritionDeviation(b,targets,input); if(Math.abs(d)>1e-9)return d;
      const p=preferenceFit(b,input.preference)-preferenceFit(a,input.preference); if(p)return p;
    }else{
      const d=nutritionDeviation(a,targets,input)-nutritionDeviation(b,targets,input); if(Math.abs(d)>1e-9)return d;
      const p=preferenceFit(b,input.preference)-preferenceFit(a,input.preference); if(p)return p;
      const cg=productGroupCount(a)-productGroupCount(b); if(cg)return cg;
      if(a.alloc.eventUseValueCents!==b.alloc.eventUseValueCents)return a.alloc.eventUseValueCents-b.alloc.eventUseValueCents;
      if(a.alloc.cartPriceCents!==b.alloc.cartPriceCents)return a.alloc.cartPriceCents-b.alloc.cartPriceCents;
    }
    return 0;
  }

  function timelineForPlan(plan,input){
    const duration=n(input.durationMin);
    const formatTime=minute=>minute<60?`${minute} perc`:`${Math.floor(minute/60)}:${String(minute%60).padStart(2,'0')}`;
    const localizedUnit=(unit,count)=>{
      if(unit==='capsule') return count===1?'kapszula':'kapszula';
      if(unit==='tablet') return count===1?'tabletta':'tabletta';
      if(unit==='scoop') return count===1?'mérőkanál':'mérőkanál';
      if(unit==='serving') return count===1?'adag':'adag';
      return unit||'db';
    };

    const drinkUses=[];
    const discreteCarbUses=[];

    for(const u of plan.uses){
      const g=CATALOG.groups[u.group];
      if(!g||n(g.carb)<=0||u.count<=0)continue;
      if(g.form==='drink'){
        drinkUses.push({group:u.group,count:u.count});
        continue;
      }
      for(let i=0;i<u.count;i++){
        discreteCarbUses.push({group:u.group,carb:n(g.carb),text:`${g.title} – ${n(g.carb)} g szénhidrát`});
      }
    }

    const events=[];
    if(plan.totalFluidMl>0){
      const hasDrink=drinkUses.length>0;
      events.push({
        timeLabel:'Folyamatosan',
        text:`Folyadék: kb. ${Math.round(plan.fluidMlph)} ml/óra, kisebb kortyokban.${hasDrink?' A bekevert sportitalon felüli folyadékot vízből fedezd.':' A folyadékot egyenletesen oszd el a terhelés során.'}`
      });
    }

    for(const u of drinkUses){
      const g=CATALOG.groups[u.group];
      if(g.waterFlexible){
        // Nduranz Nrgy Drink (electrolyte-free): manufacturer directions allow 1–4 scoops / 500 ml.
        events.push({
          timeLabel:'Folyamatosan',
          text:`${g.title}: keverj be ${u.count} mérőkanálnyit egy kulacsba az előírt vízmennyiséggel; a terhelés során egyenletesen, kisebb kortyokban fogyaszd. Ne egy időpontban idd meg.`
        });
      }else{
        const bottleCount=Math.max(1,u.count);
        events.push({
          timeLabel:'Folyamatosan',
          text:`${g.title}: ${u.count} ${localizedUnit(g.unit,u.count)} ${bottleCount===1?'egy':'külön'} kulacsban, az előírt vízmennyiséggel előre bekeverve; a terhelés során egyenletesen, kisebb kortyokban fogyaszd.`
        });
      }
    }

    const discreteTotal=sum(discreteCarbUses,x=>x.carb);
    let cum=0,last=-999;
    for(let i=0;i<discreteCarbUses.length;i++){
      const x=discreteCarbUses[i];
      const raw=discreteTotal?((cum+x.carb/2)/discreteTotal)*duration:0;
      let minute=Math.round(raw/5)*5;
      if(duration>90&&i===0&&minute<20)minute=20;
      if(minute-last<10)minute=last+10;
      if(minute>=duration)break;
      events.push({timeLabel:formatTime(minute),text:x.text});
      cum+=x.carb;
      last=minute;
    }

    if(plan.adjuster){
      const g=CATALOG.groups[plan.adjuster.group];
      const adjusterPreparedMl=preparedFluidForUse(plan.adjuster.group,1);
      if(g && adjusterPreparedMl===0 && (g.form==='capsule' || g.form==='tablet')){
        const count=Math.max(0,Math.floor(n(plan.adjuster.count)));
        const unit=localizedUnit(g.unit,count);
        if(count>0){
          events.push({
            timeLabel:'Összesen',
            text:`${g.title}: ${count} ${unit}.`
          });
        }
        for(let i=0;i<count;i++){
          let minute=Math.round((duration*(i+1)/(count+1))/5)*5;
          minute=clamp(minute,5,Math.max(5,duration-5));
          events.push({
            timeLabel:formatTime(minute),
            text:`1 ${localizedUnit(g.unit,1)}, vízzel.`
          });
        }
      }else{
        events.push({
          timeLabel:'Egyenletesen elosztva',
          text:`${g.title}: összesen ${plan.adjuster.count} ${localizedUnit(g.unit,plan.adjuster.count)}; oszd el a terhelés során, ne pótolj kimaradt adagot egyszerre.`
        });
      }
    }
    return events;
  }
  function addCaffeine(routePlan,decision,route,input,liveMap){
    if(!decision?.requested||!decision.planAllowed) return routePlan;
    const allowedTotal = mg => {
      if(decision.kind==='PRACTICED_BELOW_BAND') return Math.abs(mg-decision.exactTotalMg)<1e-9;
      if(decision.kind==='PERFORMANCE_RANGE') return mg>=decision.rangeMg[0]-1e-9&&mg<=decision.rangeMg[1]+1e-9;
      return false;
    };
    const options=[];
    if(route!=='pfh'&&groupLive(CATALOG.groups.ND_CAFF_CAP,liveMap)){
      for(let caps=1;caps<=4;caps++){

        const mg=50*caps;if(!allowedTotal(mg))continue;
        const a=allocateGroup('ND_CAFF_CAP',caps,liveMap); if(!a.ok)continue;
        options.push({mg,blocks:1,replace:null,extra:[{group:'ND_CAFF_CAP',count:caps}],alloc:a});
      }
    }
    // Substitution-first: exact nutrition-equivalent caffeinated sodium tablets when the base route already uses I:AM sodium.
    // In single-block mode only one sodium tablet may carry caffeine automatically; split mode may use at most two.
    const iamBase = routePlan.adjuster && ['IAM_120','IAM_RACE'].includes(routePlan.adjuster.group) ? routePlan.adjuster : null;
    if(route!=='pfh' && iamBase){
      const caffeinatedKey=iamBase.group==='IAM_120'?'IAM_120_CAFF':'IAM_RACE_CAFF';
      if(groupLive(CATALOG.groups[caffeinatedKey],liveMap)){
        const maxRep=Math.min(iamBase.count,decision.splitAllowed?2:1);
        for(let rep=1;rep<=maxRep;rep++){
          for(let caps=0;caps<=4;caps++){
            const mg=10*rep+50*caps;if(!allowedTotal(mg))continue;
            const ia=allocateGroup(caffeinatedKey,rep,liveMap);if(!ia.ok)continue;
            const xa=caps?allocateGroup('ND_CAFF_CAP',caps,liveMap):{ok:true,items:[],cart:0,event:0};if(!xa.ok)continue;
            options.push({mg,blocks:rep>1?2:1,replace:{from:'IAM_ADJUSTER',base:iamBase.group,to:caffeinatedKey,count:rep},extra:caps?[{group:'ND_CAFF_CAP',count:caps}]:[],alloc:{ok:true,items:[...ia.items,...xa.items],cart:ia.cart+xa.cart,event:ia.event+xa.event}});
          }
        }
      }
    }
    // Substitution-first: exact nutrition-equivalent caffeinated gels.
    const ndUse=routePlan.uses.find(u=>u.group==='ND_GEL45')?.count||0;
    if(route!=='pfh'&&ndUse>0&&groupLive(CATALOG.groups.ND_GEL45_CAFF,liveMap)){
      const max=Math.min(ndUse,decision.splitAllowed?2:1);
      for(let rep=1;rep<=max;rep++){
        for(let caps=0;caps<=4;caps++){
          const mg=65*rep+50*caps;if(!allowedTotal(mg))continue;
          const ca=allocateGroup('ND_GEL45_CAFF',rep,liveMap); if(!ca.ok)continue;
          const xa=caps?allocateGroup('ND_CAFF_CAP',caps,liveMap):{ok:true,items:[],cart:0,event:0}; if(!xa.ok)continue;
          options.push({mg,blocks:rep>1?2:1,replace:{from:'ND_GEL45',to:'ND_GEL45_CAFF',count:rep},extra:caps?[{group:'ND_CAFF_CAP',count:caps}]:[],alloc:{ok:true,items:[...ca.items,...xa.items],cart:ca.cart+xa.cart,event:ca.event+xa.event}});
        }
      }
    }
    const pfUse=(routePlan.uses.find(u=>u.group==='PF30')?.count||0)+(routePlan.uses.find(u=>u.group==='PF90')?.count||0)+(routePlan.uses.find(u=>u.group==='PF300')?.count||0);
    if(pfUse>0&&groupLive(CATALOG.groups.PF30_CAFF,liveMap)){
      const max=Math.min(pfUse,4,decision.splitAllowed?2:1);
      for(let rep=1;rep<=max;rep++){
        const mg=100*rep;if(!allowedTotal(mg))continue;
        const ca=allocateGroup('PF30_CAFF',rep,liveMap); if(!ca.ok)continue;
        options.push({mg,blocks:rep>1?2:1,replace:{from:'PF_PORTION',to:'PF30_CAFF',count:rep},extra:[],alloc:ca,pfhOk:true});
      }
    }
    const feasible=options.filter(o=>o.mg<=decision.hardHigh+1e-9&&o.blocks<=decision.maxBlocks&&(route!=='pfh'||o.pfhOk===true));
    if(!feasible.length) return {...routePlan,caffeine:{enabled:false,requestedButUnavailable:true}};
    feasible.sort((a,b)=>a.mg-b.mg||a.blocks-b.blocks||a.alloc.cart-b.alloc.cart);
    const best=feasible[0];
    const out=JSON.parse(JSON.stringify(routePlan));
    // Remove replaced sell-units from core shopping list by regenerating uses where possible.
    if(best.replace?.from==='ND_GEL45'){
      const u=out.uses.find(x=>x.group==='ND_GEL45'); if(u)u.count-=best.replace.count;
      out.uses.push({group:'ND_GEL45_CAFF',count:best.replace.count});
    }else if(best.replace?.from==='PF_PORTION'){
      let left=best.replace.count;
      for(const key of ['PF30','PF90','PF300']){ const u=out.uses.find(x=>x.group===key); if(!u||left<=0)continue; const take=Math.min(u.count,left);u.count-=take;left-=take; }
      out.uses.push({group:'PF30_CAFF',count:best.replace.count});
    }else if(best.replace?.from==='IAM_ADJUSTER'){
      if(out.adjuster?.group===best.replace.base){
        out.adjuster.count-=best.replace.count;
        if(out.adjuster.count<=0)out.adjuster=null;
      }
      out.uses.push({group:best.replace.to,count:best.replace.count});
    }
    for(const e of best.extra) out.uses.push({...e});
    const merged=new Map();for(const u of out.uses)if(u.count>0)merged.set(u.group,(merged.get(u.group)||0)+u.count);out.uses=[...merged].map(([group,count])=>({group,count}));
    out.alloc=allocatePlanItems(out,liveMap);
    out.caffeine={enabled:true,totalMg:best.mg,blocks:best.blocks,warningText:[decision.sleep?.text,'Koffeint tartalmazó termék. A címkén és termékoldalon szereplő figyelmeztetések elsőbbséget élveznek.'].filter(Boolean).join(' ')};
    return out.alloc.ok?out:routePlan;
  }

  function buildRoute(route,input,targets,decision,liveMap,options={}){
    const carbPlans=findCarbUsePlans(route,input,targets,liveMap);
    const complete=[];
    for(const cp of carbPlans){
      for(const hp of completeHydration(route,input,targets,cp,liveMap)){
        const alloc=allocatePlanItems(hp,liveMap);if(!alloc.ok)continue;
        const plan={...hp,alloc,route};
        complete.push(plan);
      }
    }
    let candidatePool=complete;
    if(typeof options.candidateFilter==='function')candidatePool=complete.filter(options.candidateFilter);
    if(!candidatePool.length)return null;
    candidatePool.sort((a,b)=>routeRank(a,b,route,input,targets));
    let selected=candidatePool[0];
    selected=addCaffeine(selected,decision,route,input,liveMap);
    if(decision?.requested&&decision.planAllowed&&selected.caffeine?.enabled!==true)return null;
    const h=Math.max(1/60,n(input.durationMin)/60);
    const carbAvg=selected.nut.carb/h;
    const title=route==='pfh'?'PF&H RENDSZER':route==='cost'?'KÖLTSÉGTUDATOS':'TBP AJÁNLOTT';
    return {
      id:`${route}-${usesKey(selected.uses)}-${selected.adjuster?selected.adjuster.group+selected.adjuster.count:'na'}-${Math.round(selected.fluidMlph)}`,
      type:route,
      variantKey:options.variantKey||null,
      displayKicker:options.displayKicker||null,
      displayTitle:options.displayTitle||null,
      summary:`${Math.round(carbAvg*10)/10} g/óra szénhidrát · ${Math.round(selected.fluidMlph)} ml/óra folyadék · ${Math.round(selected.sodiumMgL)} mg/L nátrium`,

      customerSummary: options.customerSummary || (route==='cost'?'A tápanyagcélokat teljesítő, legalacsonyabb aktuális kosárértékű végrehajtás.':route==='pfh'?'A terved végrehajtása kizárólag Precision Fuel & Hydration termékekkel.':'A megadott preferenciádhoz és a tápanyagcélokhoz illesztett végrehajtás.'),
      customerMeta:options.customerMeta || '',
      cartPriceCents:selected.alloc.cartPriceCents,
      eventUseValueCents:selected.alloc.eventUseValueCents,
      shoppingList:selected.alloc.items,
      customerReady:true,
      commercePolicy:commercePolicyForAllocation(selected.alloc),
      caffeine:selected.caffeine||{enabled:false},
      timeline:[...timelineForPlan(selected,input),...(selected.caffeine?.enabled?[{timeLabel:'Koffein',text:selected.caffeine.blocks>1?'A koffeines adagokat a korábban begyakorolt megosztásod szerint időzítsd; ne növeld a teljes dózist.':'A koffeint a korábban begyakorolt időzítésed szerint használd; ne növeld a teljes dózist.'}]:[])],
      internal:selected
    };
  }

  function buildTbpExecutionRoutes(input,targets,decision,liveMap){
    const standard=buildRoute('tbp',input,targets,decision,liveMap);
    const drink=buildRoute('tbp',input,targets,decision,liveMap,{
      candidateFilter:p=>hasCarbDrink(p),
      variantKey:'drink',
      displayKicker:'SPORTITALOS TERV',
      displayTitle:'TBP AJÁNLOTT',
      customerSummary:'Sportitalos végrehajtás: a szénhidrát egy része előre bekevert italból érkezik.'
    });
    const ph1500=buildRoute('tbp',input,targets,decision,liveMap,{
      candidateFilter:p=>!hasCarbDrink(p)&&p.adjuster?.group==='PH1500',
      variantKey:'ph1500',
      displayKicker:'ELEKTROLITOS TERV',
      displayTitle:'TBP ALTERNATÍVA',
      customerSummary:'PH 1500-as végrehajtás: a nátriumot külön elektrolitos kulacs adja, a szénhidrátot más termékekből fedezi a terv.'
    });
    if(drink&&ph1500)return [drink,ph1500];
    return standard?[standard]:[];
  }

  function dedupeRoutes(routes){
    const out=[];
    const sig=r=>(r.shoppingList||[]).map(x=>`${x.sku}:${x.sellUnits||1}`).sort().join('|')+`|c${r.caffeine?.totalMg||0}`;
    for(const r of routes.filter(Boolean)){
      const ex=out.find(x=>sig(x)===sig(r));
      if(!ex)out.push(r);
      else{
        const labels=[];if(ex.type==='cost'||r.type==='cost')labels.push('legalacsonyabb kosárérték');if(ex.type==='pfh'||r.type==='pfh')labels.push('PF&H rendszer');
        if(labels.length)ex.customerMeta=`${ex.customerMeta} · ${labels.join(' · ')}`;
      }
    }
    return out;
  }

  function keepCostRouteOnlyIfCheapest(routes){
    const deduped=dedupeRoutes(routes);
    const costRoutes=deduped.filter(r=>r.type==='cost').sort((a,b)=>n(a.cartPriceCents,Infinity)-n(b.cartPriceCents,Infinity));
    const nonCost=deduped.filter(r=>r.type!=='cost');
    if(!costRoutes.length)return nonCost;
    const bestCost=costRoutes[0];
    if(!nonCost.length)return [bestCost];
    const cheapestOther=Math.min(...nonCost.map(r=>n(r.cartPriceCents,Infinity)));
    return n(bestCost.cartPriceCents,Infinity)<cheapestOther ? [...nonCost,bestCost] : nonCost;
  }

  function rawSingle(engine,input){
    const t=engine.__test;
    const carb=t.computeCarb({durationContextMin:input.durationMin,executionDurationMin:input.durationMin,intensity:input.intensity,practiced:input.practicedCarb});
    const fluid=t.computeFluidSegment({durationMin:input.durationMin,tempC:input.tempC,humidityPct:input.humidityPct,sweat:input.sweat,bodyWeightKg:input.fluidBodyWeightKg,practicedFluidBand:input.practicedFluidBand});
    const sodium=t.computeSodiumSegment({segmentDurationMin:input.durationMin,eligibilityDurationMin:input.durationMin,fluid,sweat:input.sweat,sweatSodium:input.sweatSodium});
    const caffeine=t.computeCaffeineDecision({...input.caffeine,context:input.context},input.durationMin);
    return {targets:{carb,fluid,sodium},caffeine};
  }
  function rawTri(engine,input){
    const t=engine.__test, tri=input.tri||{};
    const eventDur=n(tri.swimMin)+n(tri.t1Min)+n(tri.bikeMin)+n(tri.t2Min)+n(tri.runMin);
    function leg(which,duration){
      const sweat=input.triSweat?.[which]||{}, sodiumInput=input.triSweatSodium?.[which]||{};
      const carb=t.computeCarb({durationContextMin:eventDur,executionDurationMin:duration,intensity:input.intensity,practiced:input.triPracticedCarb?.[which]});
      const fluid=t.computeFluidSegment({durationMin:duration,tempC:input.tempC,humidityPct:input.humidityPct,sweat,bodyWeightKg:input.fluidBodyWeightKg,practicedFluidBand:input.triPracticedFluid?.[which]});
      const sodium=t.computeSodiumSegment({segmentDurationMin:duration,eligibilityDurationMin:eventDur,fluid,sweat,sweatSodium:sodiumInput});
      return {targets:{carb,fluid,sodium}};
    }
    return {bike:leg('bike',n(tri.bikeMin)),run:leg('run',n(tri.runMin)),caffeine:t.computeCaffeineDecision({...input.caffeine,context:input.context},eventDur)};
  }
  function mergeShopping(a,b){
    const m=new Map();
    for(const item of [...(a||[]),...(b||[])]){
      const key=item.sku;const ex=m.get(key);if(ex)ex.sellUnits+=n(item.sellUnits,1);else m.set(key,{...item,sellUnits:n(item.sellUnits,1)});
    }
    return [...m.values()];
  }
  function buildTriRoutes(engine,input,liveMap){
    const raw=rawTri(engine,input),tri=input.tri||{};
    const eventDur=n(tri.swimMin)+n(tri.t1Min)+n(tri.bikeMin)+n(tri.t2Min)+n(tri.runMin);
    const routes=[];
    const mergeDosePlan=(bi,ru)=>{
      const m=new Map();
      const add=(group,count)=>{if(count>0)m.set(group,(m.get(group)||0)+count);};
      for(const u of bi.internal?.uses||[])add(u.group,u.count);
      for(const u of ru.internal?.uses||[])add(u.group,u.count);
      if(bi.internal?.adjuster)add(bi.internal.adjuster.group,bi.internal.adjuster.count);
      if(ru.internal?.adjuster)add(ru.internal.adjuster.group,ru.internal.adjuster.count);
      return {uses:[...m].map(([group,count])=>({group,count})),adjuster:null};
    };
    for(const route of ['tbp','pfh']){
      const bi=buildRoute(route,{...input,sport:'bike',durationMin:n(tri.bikeMin),preference:input.preference},raw.bike.targets,{requested:false,planAllowed:false},liveMap);
      const ru=buildRoute(route,{...input,sport:'run',durationMin:n(tri.runMin),preference:input.preference},raw.run.targets,{requested:false,planAllowed:false},liveMap);
      if(!bi||!ru)continue;
      let combined=mergeDosePlan(bi,ru);
      combined.alloc=allocatePlanItems(combined,liveMap);if(!combined.alloc.ok)continue;
      combined=addCaffeine(combined,raw.caffeine,route,{...input,durationMin:eventDur},liveMap);
      if(raw.caffeine?.requested&&raw.caffeine.planAllowed&&combined.caffeine?.enabled!==true)continue;
      const shopping=combined.alloc.items;
      let ready=true;
      for(const item of shopping){const l=liveMap.get(String(item.sku));if(!l?.available){ready=false;break;}const stock=Number(l.inventoryQuantity);if(Number.isFinite(stock)&&stock<item.sellUnits){ready=false;break;}}
      if(!ready)continue;
      const timeline=[{timeLabel:'Kerékpár',text:bi.summary},...bi.timeline,{timeLabel:'Futás',text:ru.summary},...ru.timeline];
      if(combined.caffeine?.enabled)timeline.push({timeLabel:'Koffein',text:combined.caffeine.blocks>1?'A koffeines adagokat a korábban begyakorolt megosztásod szerint időzítsd; ne növeld a teljes dózist.':'A koffeint a korábban begyakorolt időzítésed szerint használd; ne növeld a teljes dózist.'});
      routes.push({
        id:`${route}-tri-${bi.id}-${ru.id}`,type:route,

        customerSummary:route==='pfh'?'PF&H-only végrehajtás, külön kerékpáros és futó termékritmussal.':route==='cost'?'Kedvezőbb kosárértékű, külön bike/run végrehajtás.':'A tápanyagcélokhoz illesztett, külön kerékpáros és futó végrehajtás.',
        customerMeta:'',
        cartPriceCents:combined.alloc.cartPriceCents,eventUseValueCents:combined.alloc.eventUseValueCents,shoppingList:shopping,customerReady:true,commercePolicy:commercePolicyForAllocation(combined.alloc),caffeine:combined.caffeine||{enabled:false},
        timeline,internal:{bike:bi.internal,run:ru.internal,combined}
      });
    }
    return dedupeRoutes(routes);
  }

  function allCatalogRows(){
    const rows=[];for(const [groupKey,g] of Object.entries(CATALOG.groups))for(const sku of g.skus)rows.push({groupKey,sku,brand:g.brand,title:g.title,role:g.role,form:g.form||null,manualOnly:!!g.manualOnly,releaseBlocked:CUSTOMER_RELEASE_BLOCKED_SKUS.has(String(sku))});return rows;
  }

  let lastUiContext=null;

  function totalDurationMin(input){
    if(input.sport!=='tri') return n(input.durationMin);
    const t=input.tri||{}; return n(t.swimMin)+n(t.t1Min)+n(t.bikeMin)+n(t.t2Min)+n(t.runMin);
  }
  function optionalRecommendations(input,liveMap){
    const duration=totalDurationMin(input);
    const picks=[];
    const add=(groupKey,reason)=>{
      const g=CATALOG.groups[groupKey]; if(!g)return;
      for(const l of availableVariants(g,liveMap)) picks.push({groupKey,sku:l.sku,title:l.title||g.title,variantTitle:l.variantTitle||'',url:l.url||'',price:n(l.price),reason});
    };
    if(duration>=90){
      add('PJUR20','Ha nálad hosszabb terhelésen visszatérő probléma a dörzsölődés, ez egy kompakt, opcionális bőrvédelmi megoldás.');
      add('PJUR100','Ha rendszeresen használsz bőrvédelmet hosszabb terheléseken, ez a nagyobb kiszerelésű opcionális változat.');
      add('SNB','Opcionális bőrvédelem hosszabb terheléshez; csak akkor válaszd, ha ez nálad valós használati igény.');
      add('ND_REGEN','Opcionális terhelés utáni recovery termék; nem része a terhelés közbeni CH/folyadék/nátrium számításnak.');
    }
    if(duration>=60){
      add('PELOTAN_ROLL','Ha napos/UV-terheléses körülmények várhatók, opcionális sport-fényvédelem. A kalkulátor nem becsül UV-terhelést.');
      add('PELOTAN_SPRAY','Ha napos/UV-terheléses körülmények várhatók, opcionális sport-fényvédelem. A kalkulátor nem becsül UV-terhelést.');
    }
    if(input.context==='race' && (input.intensity==='race'||input.intensity==='strong')){
      add('ND_BICARB','Speciális pre-event termék. Nem kerül automatikusan a frissítési tervbe; csak begyakorolt, számodra ismert protokoll mellett mérlegeld.');
      add('VOOM_BETA','Speciális aktív energiaszelet. A koffeint/aktív összetevőket a kalkulátor nem számolja belőle automatikusan, ezért nem része a core tervnek.');
    }
    add('PICKLE','Speciális shot, amelyet a kalkulátor nem számol automatikus CH/folyadék/nátrium forrásként. Használatnál a termékcímke az irányadó.');
    add('PILLAR','Opcionális recovery/support termék; nem része a terhelés közbeni frissítési számításnak.');
    return picks;
  }
  function moneyHuf(v){ return `${Math.round(n(v)).toLocaleString('hu-HU')} Ft`; }
  function renderOptional(root,ctx){
    if(!root||!ctx)return;
    root.querySelector('[data-tbp-optional-products]')?.remove();
    const picks=optionalRecommendations(ctx.input,ctx.liveMap);
    if(!picks.length)return;
    const host=root.querySelector('[data-shopping-block]')||root.querySelector('[data-routes-block]');
    if(!host)return;
    const details=document.createElement('details');details.setAttribute('data-tbp-optional-products','');details.className='tbp-calc__why';
    const summary=document.createElement('summary');summary.textContent=`Opcionális kiegészítők (${picks.length})`;details.appendChild(summary);
    const intro=document.createElement('p');intro.className='tbp-calc__hint';intro.textContent='Ezek nem írják felül a frissítési tervedet és nem kerülnek a „Teljes terv kosárba” gombbal automatikusan a kosárba.';details.appendChild(intro);
    const grid=document.createElement('div');grid.className='tbp-calc__routes';
    for(const p of picks){
      const card=document.createElement('article');card.className='tbp-calc__route-card';
      const h=document.createElement('h4');h.textContent=p.variantTitle&&p.variantTitle!=='Default Title'?`${p.title} – ${p.variantTitle}`:p.title;
      const reason=document.createElement('p');reason.className='tbp-calc__route-copy';reason.textContent=p.reason;
      const meta=document.createElement('div');meta.className='tbp-calc__route-meta';meta.textContent=moneyHuf(p.price);
      card.append(h,reason,meta);
      if(p.url){const a=document.createElement('a');a.className='button button--secondary';a.href=p.url;a.textContent='MEGNÉZEM';card.appendChild(a);}
      grid.appendChild(card);
    }
    details.appendChild(grid);host.insertAdjacentElement('afterend',details);
  }
  function renderRouteTimeline(root,route){
    const host=root?.querySelector('[data-timeline]');if(!host||!route?.timeline?.length)return;
    host.innerHTML='';const list=document.createElement('div');list.className='tbp-calc__timeline';
    for(const e of route.timeline){const row=document.createElement('div');row.className='tbp-calc__timeline-item';const t=document.createElement('strong');t.textContent=e.timeLabel;const p=document.createElement('span');p.textContent=e.text;row.append(t,p);list.appendChild(row);}host.appendChild(list);
  }
  function renderFlavorSelectors(root,route,ctx){
    root?.querySelector('[data-tbp-flavor-selectors]')?.remove();
    const choiceItems=(route?.shoppingList||[]).filter(x=>Array.isArray(x.alternatives)&&x.alternatives.length>1);
    if(!choiceItems.length)return;
    const shopping=root.querySelector('[data-shopping-list]');if(!shopping)return;
    const box=document.createElement('div');box.setAttribute('data-tbp-flavor-selectors','');box.className='tbp-calc__subpanel';
    const title=document.createElement('h4');title.textContent='Ízválasztás';box.appendChild(title);

    for(const item of choiceItems){
      const label=document.createElement('label');label.className='tbp-calc__field';label.append(document.createTextNode(item.title||'Termék'));
      const select=document.createElement('select');
      for(const a of item.alternatives){const opt=document.createElement('option');opt.value=a.sku;opt.textContent=a.variantTitle||a.title||a.sku;if(a.sku===item.sku)opt.selected=true;select.appendChild(opt);}
      select.addEventListener('change',()=>{const chosen=item.alternatives.find(a=>a.sku===select.value);if(!chosen)return;item.sku=chosen.sku;item.title=chosen.title||item.title;item.variantTitle=chosen.variantTitle||'';});
      label.appendChild(select);box.appendChild(label);
    }
    shopping.appendChild(box);
  }
  function scheduleUiEnhancements(){
    if(typeof document==='undefined'||!lastUiContext)return;
    setTimeout(()=>{
      document.querySelectorAll('[data-tbp-calculator]').forEach(root=>{
        const routes=lastUiContext.plan.routes||[];
        const initial=lastUiContext.selectedRoute||routes[0];
        if(initial){renderRouteTimeline(root,initial);renderFlavorSelectors(root,initial,lastUiContext);}
        renderOptional(root,lastUiContext);
      });
    },0);
  }
  if(typeof document!=='undefined'){
    document.addEventListener('click',e=>{
      const btn=e.target?.closest?.('[data-select-route]');if(!btn||!lastUiContext)return;
      const root=btn.closest('[data-tbp-calculator]');if(!root)return;
      const card=btn.closest('.tbp-calc__route-card');const routeId=card?.dataset?.routeId;const route=lastUiContext.plan.routes?.find(r=>r.id===routeId);if(!route)return;
      lastUiContext.selectedRoute=route;setTimeout(()=>{renderRouteTimeline(root,route);renderFlavorSelectors(root,route,lastUiContext);},0);
    },true);
  }

  function enrich(plan,input,runtimeContext={}){
    const engine=globalThis.TBP_CALCULATOR_ENGINE;
    const liveMap=runtimeContext.liveProductMap;
    if(!engine?.__test||!liveMap?.get)return plan;
    let routes=[];
    if(input.sport==='tri') routes=buildTriRoutes(engine,input,liveMap);
    else {
      const raw=rawSingle(engine,input);
      const tbpRoutes=buildTbpExecutionRoutes(input,raw.targets,raw.caffeine,liveMap);
      routes=dedupeRoutes([
        ...tbpRoutes,
        buildRoute('pfh',input,raw.targets,raw.caffeine,liveMap)
      ]);
    }
    const enriched={...plan,routes,explanations:[...(plan.explanations||[]),{title:'Termékterv',text:routes.length?'A termékterv a nutrition target után készül; az élő Shopify ár, elérhetőség és készlet nem módosítja a tápanyagcélt.':'Ehhez a célhoz jelenleg nincs élő készletből összeállítható automatikus termékterv.'}]};
    lastUiContext={plan:enriched,input,liveMap,selectedRoute:routes[0]||null};scheduleUiEnhancements();
    return enriched;
  }

  // Keep the nutrition engine byte-identical: product execution is attached as a post-processing wrapper.
  const engine=globalThis.TBP_CALCULATOR_ENGINE;
  if(engine&&typeof engine.run==='function'&&!engine.__tbpProductPlannerWrapped){
    const baseRun=engine.run.bind(engine);
    engine.run=async function(input,runtimeContext={}){
      const base=await baseRun(input,{...runtimeContext,patternLibrary:[],triPatternLibrary:[]});
      return enrich(base,input,runtimeContext);
    };
    Object.defineProperty(engine,'__tbpProductPlannerWrapped',{value:true,enumerable:false});
  }

  globalThis.TBP_CALCULATOR_PRODUCT_CATALOG=Object.freeze({version:VERSION,generatedAt:GENERATED_AT,rows:Object.freeze(allCatalogRows())});
  globalThis.TBP_VERIFIED_PATTERN_LIBRARY=[];
  globalThis.TBP_VERIFIED_TRI_PATTERN_LIBRARY=[];
  globalThis.TBP_CALCULATOR_PRODUCT_RELEASE=Object.freeze({status:'FINAL_FULL_CATALOG',catalogSkus:allCatalogRows().length,customerReadyPatterns:'DYNAMIC_VALIDATED',releaseGate:'LIVE_STOCK_ONLY',blockedSkus:Object.freeze([...CUSTOMER_RELEASE_BLOCKED_SKUS]),generatedAt:GENERATED_AT});
  globalThis.TBPProductPlanner=Object.freeze({version:VERSION,enrich,__test:{findCarbUsePlans,completeHydration,allocateGroup,buildRoute,buildTbpExecutionRoutes,buildTriRoutes,rawSingle,rawTri,allCatalogRows}});
})();
